import { render, staticRenderFns } from "./buyQR.vue?vue&type=template&id=3a2ad423&scoped=true&"
import script from "./buyQR.vue?vue&type=script&lang=js&"
export * from "./buyQR.vue?vue&type=script&lang=js&"
import style0 from "./buyQR.vue?vue&type=style&index=0&id=3a2ad423&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2ad423",
  null
  
)

export default component.exports